/**
 * @fileoverview AccountPage icons. JSON files in `public/icons/AccountPage/`.
 */
export const ACCOUNT_ICONS = {
  accountPage: '/icons/AccountPage/wired-outline-1004-management-team-in-reveal.json',
  mailShield: '/icons/AccountPage/wired-outline-3640-mail-shield-in-assembly.json',
  fingerprint: '/icons/AccountPage/wired-outline-500-fingerprint-security-hover-pinch.json',
  statusVerified: '/icons/AccountPage/wired-outline-37-approve-checked-simple-hover-loading.json',
  statusUnverified: '/icons/AccountPage/wired-outline-38-error-cross-simple-in-reveal.json',
  /** Delete / clear (destructive) popups. Markers: in-reveal, hover-empty. */
  trashBin: '/icons/AccountPage/wired-outline-185-trash-bin-hover-empty.json',
  /** Delete-account popup. Markers: in-reveal, hover-click. */
  deleteAccount: '/icons/AccountPage/wired-outline-311-avatar-icon-trash-hover-click.json',
  /** Reset-learning-progress popup. Markers: in-reveal, hover-cycle. */
  resetLearning: '/icons/AccountPage/wired-outline-1683-recycling-hover-cycle.json',
  /** Clear-preferences-data popup. Markers: in-reveal, hover-trash. */
  clearPreferences: '/icons/AccountPage/wired-outline-3134-trash-bin-full-in-reveal.json',
  /** "Download your data" popup. Markers: in-reveal, hover-slide. */
  downloadData: '/icons/AccountPage/wired-outline-3-cloud-download-in-reveal.json',
  /** "Download our research" popup. Markers: in-reveal, hover-swipe. */
  downloadResearch: '/icons/AccountPage/wired-outline-93-document-download-in-unfold.json',
} as const;
